module.exports = __webpack_public_path__ + "static/media/multi-family.89dda50e.svg";